export {
  SettingRow,
  type SettingRowProps,
} from "./components/SettingRow/SettingRow"
